export const VENDORS_RESET_STATE = 'VENDORS_RESET_STATE';
export const VENDORS_CURRENT_ITEM = 'VENDORS_CURRENT_ITEM';

export const VENDORS_REQUEST_LOADING = 'VENDORS_REQUEST_LOADING';
export const VENDORS_REQUEST_SUCCESS = 'VENDORS_REQUEST_SUCCESS';
export const VENDORS_REQUEST_FAILED = 'VENDORS_REQUEST_FAILED';

export const VENDORS_CURRENT_ACTION = 'VENDORS_CURRENT_ACTION';
export const VENDORS_RESET_ACTION = 'VENDORS_RESET_ACTION';